var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReason5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.648 5.493C15.521 4.792 16.42 3.85 16.876 2.704C17.114 2.106 17.037 1.427 16.671 0.888C16.294 0.332 15.669 0 15 0H9C8.331 0 7.706 0.332 7.329 0.888C6.963 1.427 6.887 2.106 7.124 2.704C7.58 3.849 8.479 4.792 9.352 5.493C4.696 7.221 1 13.159 1 18C1 21.309 3.691 24 7 24H17C20.309 24 23 21.309 23 18C23 13.159 19.304 7.221 14.648 5.493ZM15.017 1.965C14.501 3.262 12.923 4.358 11.998 4.875C11.075 4.362 9.503 3.275 8.999 2L15.017 1.965ZM16.999 22H7C4.794 22 3 20.206 3 18C3 12.757 7.71 7 12 7C16.29 7 21 12.757 21 18C21 20.206 19.205 22 16.999 22ZM11.999 22C11.447 22 10.999 21.552 10.999 21V20H10.731C9.663 20 8.668 19.426 8.133 18.501C7.857 18.023 8.02 17.412 8.498 17.135C8.974 16.858 9.587 17.021 9.864 17.5C10.042 17.808 10.375 18 10.731 18H12.999C13.55 18 13.999 17.551 13.999 17C13.999 16.622 13.728 16.302 13.355 16.24L10.313 15.733C8.972 15.51 7.998 14.36 7.998 13C7.998 11.346 9.344 10 10.998 10V9C10.998 8.448 11.446 8 11.998 8C12.55 8 12.998 8.448 12.998 9V10H13.266C14.333 10 15.329 10.575 15.864 11.5C16.14 11.978 15.977 12.589 15.499 12.866C15.022 13.143 14.41 12.98 14.133 12.501C13.954 12.192 13.622 12.001 13.266 12.001H10.998C10.447 12.001 9.998 12.45 9.998 13.001C9.998 13.379 10.269 13.699 10.642 13.761L13.684 14.268C15.025 14.491 15.999 15.641 15.999 17.001C15.999 18.655 14.653 20.001 12.999 20.001V21.001C12.999 21.553 12.551 22 11.999 22Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_851"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReason5);
export default __webpack_public_path__ + "static/media/reason5.b07d519f34bf8580713993889b6e0918.svg";
export { ForwardRef as ReactComponent };